import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useEffect, useRef, useState } from "react";
import {
  Button,
  Card,
  CardHeader,
  Container,
  Form,
  FormGroup,
  Input,
  InputGroup,
  Label,
  Modal,
  ModalBody,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import firebase from "../config/firebase";
import { useDispatch, useSelector } from "react-redux";
import cross from "../assets/img/cross.svg";
import { register } from "store/actions/authAction";
import { getSubAdmins } from "store/actions/subAdminAction";
import { deleteSubAdmin } from "store/actions/subAdminAction";
import { updatePermissions } from "store/actions/subAdminAction";

const SubAdmin = () => {
  let dispatch = useDispatch();
  const fileInputRef1 = useRef(null);
  let { uid, user } = useSelector((state) => state.auth);
  let { subAdmins } = useSelector((state) => state.subAdminData);
  const [data, setData] = useState({
    img: null,
    name: "",
    email: "",
    password: "",
    school_admin_id: uid,
    permissions_school_ip: false,
    county: user.county,
    state: user.state,
    instituteName: user.instituteName,
    instituteLevel: user.instituteLevel,
    role: "school-sub-admin",
    type: user.type,
    contract: true,
    ip_contract: false,
    created_at: firebase.firestore.FieldValue.serverTimestamp(),
  });
  const handleChange = (e) => {
    const { name, value } = e.target;
    setData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };
  const [loader, setLoader] = useState({
    data: false,
    btn: false,
  });
  const [createModal, setCreateModal] = useState(false);
  const [permissionModal, setPermissionModal] = useState(false);
  const [permission, setPermission] = useState({
    permissions_school_ip: false,
    id: "",
  });
  const [deleteData, setDeleteData] = useState({});
  const [deleteModal, setDeleteModal] = useState(false);
  const deleteModalToggle = () => {
    setDeleteModal(!deleteModal);
  };
  const permissionSubAdminModal = () => {
    setPermissionModal(!permissionModal);
  };
  const createSubAdminModal = () => {
    setCreateModal(!createModal);
  };
  useEffect(() => {
    setLoader((prev) => ({
      ...prev,
      data: true,
    }));
    dispatch(
      getSubAdmins(uid, () => {
        setLoader((prev) => ({
          ...prev,
          data: false,
        }));
      })
    );
  }, []);
  const deleteUser = () => {
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      deleteSubAdmin(deleteData.id, () => {
        deleteModalToggle();
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  const submitDataPermission = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      updatePermissions(permission, () => {
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
        permissionSubAdminModal();
      })
    );
  };
  const submitData = (e) => {
    e.preventDefault();
    setLoader((prev) => ({
      ...prev,
      btn: true,
    }));
    dispatch(
      register(data, (res) => {
        if (res == "success") {
          createSubAdminModal();
          setData({
            img: null,
            name: "",
            email: "",
            password: "",
            school_admin_id: uid,
            permissions_school_ip: false,
            county: user.county,
            state: user.state,
            instituteName: user.instituteName,
            instituteLevel: user.instituteLevel,
            role: "school-sub-admin",
            contract: true,
            ip_contract: false,
            created_at: firebase.firestore.FieldValue.serverTimestamp(),
          });
        }
        setLoader((prev) => ({
          ...prev,
          btn: false,
        }));
      })
    );
  };
  return (
    <>
      <OnlyHeader />

      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between align-items-center">
                <h3 className="mb-0 whitespace-nowrap">
                  {user.type == "school platform" ? "School" : "Collective"}{" "}
                  Users
                </h3>
                <div className="d-flex  justify-content-center align-items-center">
                  <Button
                    color="primary"
                    onClick={createSubAdminModal}
                    className="whitespace-nowrap"
                  >
                    Create Sub Admin
                  </Button>
                </div>
              </CardHeader>
              {loader.data ? (
                <div className="text-center my-4">
                  <Spinner color="primary" />
                </div>
              ) : (
                <Table className="align-items-center table-flush" responsive>
                  <thead className="thead-light">
                    <tr>
                      <th scope="col">Name</th>
                      <th scope="col">Email</th>
                      <th scope="col">Photo</th>
                      <th scope="col" className="text-center">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {subAdmins.length > 0 ? (
                      subAdmins.map((items, index) => {
                        return (
                          <tr key={index}>
                            <td>{items.name}</td>
                            <td>{items.email}</td>
                            <td>
                              <img
                                src={items.admin_image.url}
                                alt=""
                                width={100}
                              />
                            </td>
                            <td className="text-center">
                              {user.type == "school platform" && (
                                <Button
                                  color="primary"
                                  size="sm"
                                  onClick={() => {
                                    setPermission((prev) => ({
                                      ...prev,
                                      permissions_school_ip:
                                        items.permissions_school_ip,
                                      id: items.id,
                                    }));
                                    permissionSubAdminModal();
                                  }}
                                >
                                  Permission
                                </Button>
                              )}
                              <Button
                                color="danger"
                                size="sm"
                                onClick={() => {
                                  deleteModalToggle();
                                  setDeleteData(items);
                                }}
                              >
                                Delete
                              </Button>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td>N/A</td>
                        <td>N/A</td>
                        <td>N/A</td>
                      </tr>
                    )}
                  </tbody>
                </Table>
              )}
            </Card>
          </div>
        </Row>
      </Container>
      <Modal isOpen={createModal} toggle={createSubAdminModal} size="md">
        <ModalBody>
          <Form onSubmit={submitData}>
            <Container>
              <h1 className="text-center mb-4">Add Sub Admin Data</h1>
              <div className=" d-flex flex-column align-items-start mb-3">
                <Label className="auth-label mt-4">Photo ID</Label>
                <Input
                  type="file"
                  ref={fileInputRef1}
                  required
                  name="player_img"
                  accept="image/png, image/gif, image/jpeg"
                  onChange={(e) =>
                    setData((prev) => ({
                      ...prev,
                      img: e.target.files[0],
                    }))
                  }
                />
                {data.img && (
                  <div className="position-relative mt-3">
                    <img
                      src={URL?.createObjectURL(data.img)}
                      alt=""
                      className=" mt-2"
                      width={80}
                      height={80}
                    />
                    <img
                      src={cross}
                      width={20}
                      alt=""
                      className="position-absolute"
                      style={{
                        top: "-11%",
                        left: "80%",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        setData((prev) => ({
                          ...prev,
                          img: "",
                        }));
                        fileInputRef1.current.value = "";
                      }}
                    />
                  </div>
                )}
              </div>
              <FormGroup>
                <Label for="name">Name</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="name"
                    placeholder="Name"
                    type="text"
                    value={data.name}
                    onChange={handleChange}
                    name="name"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="email">Email</Label>
                <InputGroup className="input-group-alternative mb-3">
                  <Input
                    id="email"
                    placeholder="Email"
                    type="email"
                    autoComplete="new-email"
                    value={data.email}
                    onChange={handleChange}
                    name="email"
                    required
                  />
                </InputGroup>
              </FormGroup>
              <FormGroup>
                <Label for="password">Password</Label>
                <InputGroup className="input-group-alternative">
                  <Input
                    id="password"
                    placeholder="Password"
                    type="password"
                    autoComplete="new-password"
                    value={data.password}
                    onChange={handleChange}
                    name="password"
                    required
                  />
                </InputGroup>
              </FormGroup>
              {user.type == "school platform" && (
                <>
                  <Label className="mb-3">Permissions</Label>
                  <div>
                    <Input
                      type="checkbox"
                      className="custom-checkbox m-0 mt-1"
                      checked={data.permissions_school_ip}
                      onChange={(e) =>
                        setData((prev) => ({
                          ...prev,
                          permissions_school_ip: e.target.checked,
                        }))
                      }
                    />
                    <Label className="custom-checkbox-label text-dark mx-4 px-2 mt-0">
                      School Ip
                    </Label>
                  </div>
                </>
              )}
            </Container>
            <div className="text-right mt-4">
              <Button onClick={createSubAdminModal}>Cancel</Button>
              <Button color="primary" type="submit">
                {loader.btn ? <Spinner size="sm" /> : "Submit"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal
        isOpen={permissionModal}
        toggle={permissionSubAdminModal}
        size="md"
      >
        <ModalBody>
          <Form onSubmit={submitDataPermission}>
            <Container>
              <h1 className="text-center mb-4">Permissions</h1>
              <div>
                <Input
                  type="checkbox"
                  className="custom-checkbox m-0 mt-1"
                  checked={permission.permissions_school_ip}
                  onChange={(e) =>
                    setPermission((prev) => ({
                      ...prev,
                      permissions_school_ip: e.target.checked,
                    }))
                  }
                />
                <Label className="custom-checkbox-label text-dark mx-4 px-2 mt-0">
                  School Ip
                </Label>
              </div>
            </Container>
            <div className="text-right mt-4">
              <Button onClick={permissionSubAdminModal}>Cancel</Button>
              <Button color="primary" type="submit">
                {loader.btn ? <Spinner size="sm" /> : "Submit"}
              </Button>
            </div>
          </Form>
        </ModalBody>
      </Modal>
      <Modal isOpen={deleteModal} centered toggle={deleteModalToggle}>
        <ModalBody>
          <div className="text-center">
            <span className="mt-5" style={{ fontSize: 30 }}>
              Are you sure?
            </span>
            <br />
            <br />
            <span className="mt-5" style={{ fontSize: 16 }}>
              You want to delete {deleteData.name} sub admin.
            </span>
            <br />
            <br />
            <br />
            <Button color="secondary" onClick={deleteModalToggle}>
              Cancel
            </Button>
            <Button color="primary" onClick={() => deleteUser()}>
              {loader.btn ? <Spinner size="sm" /> : "Logout"}
            </Button>
          </div>
        </ModalBody>
      </Modal>
    </>
  );
};

export default SubAdmin;
